import { Plus } from 'assets/icons';
import { generateEmployeeColor } from 'helper/helper';

// An employee's initials on the colour of their name, as on the mission
// cards; nobody, a dashed circle with a plus.
const EmployeeAvatar = ({ employee, size = 24 }) => {
  const style = { width: size, height: size };
  if (!employee) {
    return (
      <span
        className="flex shrink-0 items-center justify-center rounded-full text-gray-700 outline-dashed outline-gray-300"
        style={style}
      >
        <Plus wh={16} color="currentColor" />
      </span>
    );
  }
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-full text-[10px] text-white"
      style={{ ...style, backgroundColor: generateEmployeeColor(employee.firstname, employee.lastname) }}
    >
      {`${employee.firstname?.charAt(0).toUpperCase() ?? ''}${employee.lastname?.charAt(0).toUpperCase() ?? ''}`}
    </span>
  );
};

export default EmployeeAvatar;
